const analyticViewAnswer = (Analytic) => {
    Analytic.prototype.viewAnswerPage = function (answer_id) {
        this.track('View Answer Page', {answer_id})
    }
}

export default analyticViewAnswer